export type SystemItem = {
  number: string
  emoji: string
  title: string
  intro: string[]
  listTitle: string
  points: string[]
}

export const systems: SystemItem[] = [
  {
    number: 'SYSTEM #1',
    emoji: '📘',
    title: 'Set Up Your Appliance Repair Business',
    intro: [
      'Stop operating like an amateur and build the foundation of a professional appliance repair business from day one.',
      'Organize your business structure, establish your core processes and avoid the mistakes that keep technicians stuck.',
    ],
    listTitle: "You'll learn how to:",
    points: [
      'Establish your business foundation.',
      'Organize your basic operations.',
      'Define your service process.',
      'Create a professional workflow.',
      'Start operating with greater structure.',
    ],
  },
  {
    number: 'SYSTEM #2',
    emoji: '💰',
    title: 'Charge Like a Premium Technician',
    intro: [
      'One of the biggest mistakes technicians make is charging “whatever seems fair.”',
      'Learn how to calculate profitable prices based on your actual costs, time and desired profit — so you stop giving away your work.',
    ],
    listTitle: "You'll learn how to:",
    points: [
      'Calculate your real service cost.',
      'Factor in labor and operating expenses.',
      'Build profitable pricing.',
      'Create professional estimates.',
      'Stop undercharging for your expertise.',
    ],
  },
  {
    number: 'SYSTEM #3',
    emoji: '⚙️',
    title: 'Repairs Without the Chaos',
    intro: [
      'Implement a clear workflow from the moment a customer contacts you until the appliance is delivered.',
      'Less confusion. Less rework. More speed. More organization. More confidence.',
    ],
    listTitle: "You'll create a repeatable process for:",
    points: [
      'Customer intake.',
      'Appliance diagnosis.',
      'Estimates.',
      'Repair workflow.',
      'Quality control.',
      'Delivery.',
      'Follow-up.',
    ],
  },
  {
    number: 'SYSTEM #4',
    emoji: '🤝',
    title: 'Customers Who Refer You',
    intro: [
      "A repair shouldn't end when you hand the appliance back to the customer.",
      'Create a professional customer experience designed to increase the chances that customers come back and recommend you.',
    ],
    listTitle: "You'll get tools for:",
    points: [
      'Customer communication.',
      'Follow-up.',
      'Post-repair service.',
      'Referral generation.',
      'Customer retention.',
      'Professional service delivery.',
    ],
  },
  {
    number: 'SYSTEM #5',
    emoji: '📈',
    title: 'Customers Every Month',
    intro: [
      'Simple strategies to create a more consistent flow of opportunities.',
      'Stop relying exclusively on random word-of-mouth and start building a system that keeps bringing new opportunities into your business.',
    ],
    listTitle: 'Your monthly opportunity engine:',
    points: [
      'WhatsApp.',
      'TikTok.',
      'Local referrals.',
      'Customer follow-up.',
      'Repeat business.',
    ],
  },
  {
    number: 'SYSTEM #6',
    emoji: '📂',
    title: 'Business Ready to Operate',
    intro: [
      'The heart of Technical System PRO 360™.',
      'Instead of spending nights creating paperwork… download it, customize it, use it.',
    ],
    listTitle: '300+ professional documents ready to edit, print and use:',
    points: [
      'Templates and contracts.',
      'Service orders.',
      'Warranties.',
      'Inventory forms.',
      'Operational checklists.',
      'Business forms.',
    ],
  },
]
